import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useMemo, useRef } from "react";
import * as Styled from "./style";
import type { SampleViewerModalProps } from "~/components/blocks/product/common/video-legacy-season/sample-viewer-modal";

import { useSampleViewer } from "~/components/blocks/product/common/video-legacy-season/sample-viewer-modal/desktop/use-sample-viewer";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";

const BUTTON_NAME = {
  prev: "prevButton",
  next: "nextButton",
} as const;

export type Horizontal = "toRight" | "toLeft";

export const DesktopModalBody = (props: SampleViewerModalProps) => {
  const { selectedSampleImageIndex, gravureSeasonImageData } = props;
  const { handleClickByDevice } = useHandleClickByDevice();
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const imageDataLength = useMemo(() => gravureSeasonImageData.length, []);

  const { pageIndex, onNextIndex, onPrevIndex } = useSampleViewer({
    modalBodyRef,
    selectedSampleImageIndex,
    imageDataLength,
  });

  return (
    <Styled.DivContainer ref={modalBodyRef}>
      <Styled.DivImageWrapper>
        <Styled.ImgGravure
          src={gravureSeasonImageData[pageIndex].imageLarge || gravureSeasonImageData[pageIndex].image}
          alt={`グラビア画像-${pageIndex}`}
        />
      </Styled.DivImageWrapper>

      <Styled.DivWrapScreen
        role="button"
        horizontal="toRight"
        {...handleClickByDevice<HTMLDivElement>(() => onNextIndex())}
      />
      <Styled.DivWrapScreen
        role="button"
        horizontal="toLeft"
        {...handleClickByDevice<HTMLDivElement>(() => onPrevIndex())}
      />

      <Styled.ButtonIconWrapper
        type="button"
        name={BUTTON_NAME.next}
        aria-label={BUTTON_NAME.next}
        horizontal="toRight"
        {...handleClickByDevice<HTMLButtonElement>(() => onNextIndex())}
      >
        <Icon name="arrowRight" size="XL" />
      </Styled.ButtonIconWrapper>

      <Styled.ButtonIconWrapper
        type="button"
        name={BUTTON_NAME.prev}
        aria-label={BUTTON_NAME.prev}
        horizontal="toLeft"
        {...handleClickByDevice<HTMLButtonElement>(() => onPrevIndex())}
      >
        <Icon name="arrowLeft" size="XL" />
      </Styled.ButtonIconWrapper>

      <Styled.DivPageIndexWrapper>
        {pageIndex + 1}/{imageDataLength}
      </Styled.DivPageIndexWrapper>
    </Styled.DivContainer>
  );
};
